// Load boards & Brokerage partners for Excelence Inc

export const LOAD_BOARDS = [
  'Carvana',
  'Acertus',
  'CarsArrive',
  'Auto Haul Exchange',
  'ACI',
  'ACV',
  'Montway',
  'Carpool',
  'United Road',
  'Runbuggy',
  'Roadside',
  'Reindeer',
  'Dispatch Center',
  'RoadRunner',
  'RPM',
  'Autosled',
  'CarShipIO',
];

// Brokerage companies we've worked with — cleaned & deduplicated
export const BROKERAGES = [
  '101 Motorsports',
  '314 Logistics LLC',
  '365 Car Transport',
  '4-Wheel Chassics LLC',
  '74 Auto',
  'A & A Motors',
  'AAA Transporters',
  'Acertus',
  'ACI Transport',
  'Affordable Auto Transport LLC',
  'AJN Auto Transport LLC',
  'Aline Transports',
  'All Four Transport',
  'All Stars Auto Deals Inc',
  'All State To State Auto Transport',
  'Alliance Auto Logistics LLC',
  'Almadina Shipping LLC',
  'Alpine Motorsports Corp',
  'Always Available Auto Transport Inc',
  'American Auto Link LLC',
  'American Carship Inc',
  'American Shipping Corp',
  'Amerikaz Savage LLC',
  'Anew Solutions',
  'Anew Transport',
  'AP Vintage Motors LLC',
  'APX Auto Brokers LLC',
  'Arma Express LLC',
  'Arrange Transport Ocean View Norfolk, VA',
  'Aschenbach Chevrolet GMC',
  'Asia Motors Inc',
  'ATS Finance Inc',
  'Auto Boutique Texas LLC',
  'Auto Car Zone LLC',
  'Auto Driveaway',
  'Auto Express Inc.',
  'Auto Haul Express LLC',
  'Auto Hauler Exchange',
  'Auto Hub Inc',
  'Auto Line Logistics',
  'Auto Moto Deals and Ridesafely',
  'Auto Moto Deals LLC',
  'Auto Ninjas LLC',
  'Auto Resources Corp',
  'Auto Show Case Inc',
  'Auto Web Expo Inc',
  'AutoClear Technology Limited',
  'AutoFast Logistics LLC',
  'Automovers Logistics',
  'AutoStar Transport Express LLC',
  'AutoWorld',
  'Avorix',
  'AZM Auto Shippers',
  'B & B Auto Sales',
  'B&C Logistics LLC',
  'BAH Logistics LLC',
  'Baier Automotive Logistics',
  'Barco Rent-A-Truck',
  'Baseline 4x4 Recyclers',
  'Bears Transport LLC',
  'Becdar Financial Investments LLC',
  'Benson AutoTrans LLC',
  'Best Way Auto Transport LLC',
  'Bionic Logistic Solutions LLC',
  'Bob Smith Motors Inc',
  'Boxbee Logistics LLC',
  'BR Moves LLC',
  'Breeze Auto Sales',
  'Broadreach Logistics, LLC',
  'Bullocks Auto Sales',
  'Burov Motors LLC',
  'BuyCarShipCar LLC',
  'C & M Brokerage LLC',
  'C&P Auto Transport Express LLC',
  'Capitol Auto Transport',
  'Capstone Auto Trans Inc',
  'Car City Wholesale LLC',
  'Car Haul Direct Inc',
  'Car Nation LLC',
  'Car Smart Auto Sales',
  'Car-Go Automotive Group Inc',
  'Cargoloop LLC',
  'Carmi CDJR',
  'Carmove Inc',
  'Carneed Inc',
  'Caromoto',
  'CarPlug',
  'Carrier Connect, LLC',
  'Cars Of North East Corporation',
  'CarsArrive',
  'Carshipping Express Inc',
  'Carvoya Inc',
  'Carway Group Inc',
  'Castle Buick GMC Inc',
  'Cavalier Auto Transport LLC',
  'Cayad Services LLC',
  'Central Auto Sales',
  'Century Trucks & Vans',
  'Cierta Corporation',
  'Circle Logistics, Inc',
  'Class Auto Trade Inc',
  'Classique Companies',
  'Clockwork Auto Transport LLC',
  'Colby Auto Investment, Inc',
  'Complete Auto Transport',
  'Consumer Direct Transport',
  'Copart',
  'Corsia Logistics',
  'Country Chevrolet',
  'Course Correct LLC',
  'Courtesy Chrysler Jeep Dodge Ram',
  'Crawford Logistics LLC',
  'Crescent Motors',
  'Cuda Express Logistics',
  'DASH Auto Logistics',
  'Dave Arbogast Buick- GMC',
  'Dealers Choice Auto Transport Inc',
  'Derek Flora',
  'Dillon\'s Auto Sales Inc',
  'Dimi Noble Inc',
  'Direct Connect Logistix',
  'Doering Fleet Management LLC',
  'Door to Door Transport',
  'Double G Auto LLC',
  'Dream Auto Sales Inc',
  'Driven Auto of Oak Forest',
  'Dunn Deal Auto LLC',
  'Duvall Ford Company',
  'Dynamic Auto Movers LLC',
  'Dynamic Transportation And Logistics',
  'E&G Elite Logistics LLC',
  'East Coast Auto Broker LLC',
  'East Columbus Auto Sales',
  'Easy Auto Ship',
  'Easy Cargo Ship LLC',
  'Easy Peasy USA Logistics LLC',
  'EasyGo Logistics LLC',
  'Ecarzz LLC',
  'Eclipse Auto Transport LLC',
  'Edego Auto Transport LLC',
  'Elevated Fleet Logistics',
  'Elhaj Trading LLC',
  'Elite Auto Shipping Inc',
  'Empire Trucking Services Inc',
  'Enterprise Auto Transport',
  'Evans Auto LLC',
  'Evans Motors, Inc.',
  'Evergreen Logistical Services, LLC',
  'Exclusive Transport Group LLC',
  'Expedited Freight LLC',
  'Expedited Transport Solutions LLC',
  'Express 4x4 Truck Rental',
  'Express Auto Brokerage',
  'Fastrack Auto Transport',
  'FCM Auto Group',
  'FCT Transport & More, Inc',
  'Federal Auto Shipping LLC',
  'Fenix International LLC',
  'Finley Holdings LLC',
  'First Line Transport Inc',
  'Fleet Capital Remarketing',
  'Flexco',
  'Formula Transport LLC',
  'Fortune Transportation LLC',
  'Fox Auto Transport LLC',
  'Freedom Logistics',
  'Freedom Motors USA, Inc.',
  'Freeway Auto Transport',
  'GCB Transport LLC',
  'Getaway Day Agency LLC',
  'GetCarrier LLC',
  'Glass Hauling Services, LLC',
  'Glizzy Auto Sales LLC',
  'Global Auto Exchange LLC',
  'Global Used Cars, Inc',
  'Gold Point Transport',
  'Golden Circle Ford',
  'Goldman World Logistics LLC',
  'Goliath Auto Transport',
  'Government Fleet Sales LLC',
  'Graham Family Auto Transport',
  'Groupon Freight LLC',
  'Gus & Company Inc',
  'Hanna Imports',
  'Harvest Auto Family',
  'Haulible LLC',
  'Haus Auto Transport LLC',
  'Highline Auto Sales Inc',
  'Huck Logistics LLC',
  'Hundai Motors LLC',
  'Hunsaker Enterprises LLC dba Modern Motorcars',
  'International Auto Inc',
  'J Santos Auto Sales',
  'J&S Auto Haus',
  'Jay Dee',
  'JCT Automotive LLC',
  'Joel Lang Associate',
  'JS Transport Services, Inc.',
  'Keyless Auto Sales LLC',
  'KVB Auto Transport',
  'L&R Auto Brokers',
  'Lake City Auto',
  'Lakeside Motors Inc',
  'Leader Auto Ship LLC',
  'Legacy Premier Transport LLC',
  'Lepke Auto Transport',
  'Loadmaster Group Inc',
  'Lou Fusz Automotive',
  'Lube Avto Shipping LLC',
  'Lucky Motors',
  'MAB PK Management Corp',
  'Mapa 2020 LLC',
  'Maple Tree Auto Sales LLC',
  'Mathis Motors',
  'Mazzy Express Inc',
  'MBA Logistics LLC',
  'Melniks Automotive',
  'Mercury Auto Transport',
  'Mid MO Diesel Auto Sales LLC',
  'Mid-South Logistics LLC',
  'Mile Auto Transport LLC',
  'Mile High Auto Sales LLC',
  'Millennium Motors',
  'Mint Motorworks Corp',
  'MJD Unique Logistics LLC',
  'Monarch Transport Group Inc',
  'Montway Auto Transport',
  'Morel M Import LLC',
  'MotorMate',
  'Motorsports of Chicago',
  'Mountain State Auto Auction Inc.',
  'Moving Kingdom Inc.',
  'MSM Freight Inc',
  'Multi Dispatch Services LLC',
  'Murphy Auto Transport Service',
  'N&H Group Inc',
  'National Freight & Logistics LLC',
  'Nations Auto Transport LLC',
  'Nationwide Transportation Specialists, LLC',
  'Navi Transport Services LLC',
  'Neptune Auto Transport LLC',
  'Neuhoff Auto Sales',
  'Newman Industries',
  'Nextgen Performance Limited Partnership',
  'Nextrade LLC',
  'Nexus',
  'Northway Automotive Inc',
  'One Stop Auto Sale',
  'Ortus USA LLC',
  'Osagi Enterprise',
  'PA Avto LLC',
  'PAAutoSales.Com',
  'Paramount Auto',
  'Patriot Transport USA',
  'PB Motorsales Inc',
  'PC Investments LLC',
  'Pinnacle Logistic Technologies',
  'Plateno LLC',
  'Platinum Global Motors LLC',
  'PLC Auction Inc',
  'Power2ship Inc',
  'Premier CDJR of Lamesa',
  'Premium Auto Transportation',
  'Preowned Auto Logistics, Inc.',
  'Prepzone Logistics LLC',
  'Prestige Auto Transport LLC',
  'Price\'s',
  'Prime Move Logistics LLC',
  'Prime Way Transportation Inc',
  'Professionals Auto Sales Inc',
  'Q Financial Cars',
  'Quickship LLC',
  'Ram Auto Logistics',
  'Rapid Auto Logistics',
  'RC Logistics LLC',
  'ReCar LLC',
  'Red Carpet Transport Solutions LLC',
  'Redline Motor Group',
  'Reindeer Auto Relocation',
  'Rivas Logistics LLC',
  'Riverwatch Auto Sales',
  'RL Auto Transport Corp',
  'RNG Auto Transport LLC',
  'Roadside Auto & Truck Transport',
  'Roam Auto Relocation',
  'Ronald Auto Express LLC',
  'Rosental Auto Group',
  'Royal Auto Ship LLC',
  'Royal Port Logistics',
  'Royalty Logistics LLC',
  'RPM',
  'RTR Automotive Solutions',
  'RUD Fleet Corporation',
  'Rush Logistics LLC',
  'Rust Auto Shippers',
  'S. Gail Force LLC',
  'SaaS Logistic, LLC',
  'Safe Ship Moving Services',
  'Safeeds Transport Inc',
  'Safemile Auto Transport',
  'Salut Transportation',
  'Scott\'s Auto Carrier Inc',
  'Secure Car Shipping LLC',
  'Secured Transport Inc',
  'SGT Auto Transport',
  'Shank Bros Auto Logistics',
  'Shelton Automotive Group LLC',
  'Shifted',
  'Ship A1 LLC',
  'Ship Guy Logistics LLC',
  'Ship Your Car Safely',
  'ShipCargo Technologies LLC',
  'Shipwit Global Inc.',
  'ShipYourCarNow LLC',
  'Silver Star Motors LLC',
  'Smart Car Ship',
  'SMD Auto LLC',
  'Southern Base Dispatch Services',
  'Speedco Logistics LLC',
  'Speedy Wheels Logistics Corp',
  'St James Auto & Truck Parts LLC',
  'Stopwatch LLC',
  'Stovall Used Cars',
  'Stratton Auto Transport',
  'Streamline Auto Logistics',
  'Street Prodigy Auto LLC',
  'Sullivan Auto Transport',
  'Summit Auto Sales',
  'Summit Auto Transport',
  'Sunshine Stepvans LLC',
  'Superior Buick GMC',
  'Surface Inc',
  'Sweetie Boy Home Delivery LLC',
  'Swiftland Auto Transport LLC',
  'Syngin',
  'T&J Auto Transport LLC',
  'Tailgate Motor Co',
  'Tak Transport',
  'Tarpon Transportation Services Inc.',
  'Teranga Auto',
  'TFI Trans Inc',
  'The Finest Carrier Logistics Inc',
  'The Import Guys',
  'The Transport Buddy LLC',
  'The Truck Shop LLC',
  'Thomas Auto & Diesel Service LLC',
  'Tnt Auto Sales & Services Inc',
  'Tony Motors',
  'Top Choice Transportation',
  'Top Gear Motors LLC',
  'Toyota of Hackensack',
  'TP Transport',
  'Transport Pacific Inc.',
  'Transportation Optimization Technologies C',
  'Travers Auto Logistics Inc',
  'Tri County Motors LLC',
  'Triumph Auto Sales LLC',
  'Trustline Carriers LLC',
  'Twenty7 Brokerage and Logistics, LLC',
  'U Car Connect Inc.',
  'Ultimate Transport 123',
  'Under the Hood Co',
  'Unisell Auto',
  'United Freeway Transportation LLC',
  'United Routers LLC',
  'Unsurpassed Holdings LLC',
  'US Car-Go Freight Logistics LLC',
  'USA Carship Inc',
  'Uship Logistics LLC',
  'Usko Logistics Inc',
  'Uwon LLC',
  'Van 3 Auto Transport Inc',
  'Van\'s Auto Sales',
  'Veit\'s-Vettes and Collector Cars',
  'Verily Solutions',
  'Victory Nissan Chesterton (fka Bosak Auto)',
  'VRCG Inc',
  'VS Auto Sales',
  'Wallingford Auto Park Inc',
  'WaveX Logistics LLC',
  'WeShipCars',
  'Western Specialty Vehicle Sales',
  'Wheelsup Auto Transport',
  'Wholesale Remarketing Inc',
  'Wilson Auto Family',
  'Xpress Auto Transportation Inc',
  'XWay Transport',
  'Yellowfin Logistics LLC',
  'Yerty Auto Service',
  'Zak\'s Auto Inc',
  'Zlogistics USA',
  'Zodiak Transportation and Logistics Solutions LLC',
];
